import React from 'react'

const ManagementTasksSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_700_36980)" />
    <path
      d="M40.6702 46.6105C38.0891 46.6105 35.5081 46.6105 32.9271 46.6105C31.9592 46.6105 31.0989 45.9652 30.8838 45.1049C30.5612 43.8144 31.5291 42.5776 32.8196 42.5776C35.1317 42.5776 37.4439 42.5776 39.756 42.5776C42.6597 42.5776 45.6171 42.5776 48.5207 42.5776C49.4348 42.5776 50.2952 43.2767 50.4565 44.137C50.6716 45.0511 50.2414 46.019 49.3811 46.3954C49.0584 46.5567 48.682 46.6105 48.3594 46.6105C45.886 46.6105 43.2512 46.6105 40.6702 46.6105Z"
      fill="white"
    />
    <path
      d="M40.724 26.6076C38.143 26.6076 35.562 26.6076 32.981 26.6076C31.798 26.6076 30.8839 25.7473 30.8839 24.5643C30.8839 23.4351 31.798 22.521 32.981 22.521C38.143 22.521 43.3588 22.521 48.5208 22.521C49.65 22.521 50.4566 23.2738 50.6179 24.3492C50.7254 25.3709 50.0802 26.285 49.0048 26.5538C48.8435 26.6076 48.6821 26.6076 48.5208 26.6076C45.886 26.6076 43.305 26.6076 40.724 26.6076Z"
      fill="white"
    />
    <path
      d="M40.7239 32.3074C43.3586 32.3074 45.9397 32.3074 48.5744 32.3074C49.5423 32.3074 50.4027 33.0602 50.564 33.9743C50.7253 34.996 50.1876 35.9639 49.1659 36.2327C48.9508 36.3403 48.7357 36.3403 48.5207 36.3403C43.3049 36.3403 38.0891 36.3403 32.8733 36.3403C31.7979 36.3403 30.9375 35.5337 30.83 34.4583C30.7224 33.4366 31.4215 32.5225 32.4969 32.3074C32.6582 32.2537 32.8195 32.2537 32.9808 32.2537C35.5618 32.3074 38.1428 32.3074 40.7239 32.3074Z"
      fill="white"
    />
    <path
      d="M22.9795 34.0728C23.7323 33.32 24.3776 32.5672 25.0766 31.8682C25.3992 31.5456 25.6681 31.2229 25.9907 30.9003C26.636 30.2551 27.5501 30.2551 28.1953 30.8465C28.8406 31.438 28.8406 32.4059 28.2491 33.0511C27.0124 34.3954 25.7756 35.6859 24.5389 36.9764C23.4635 38.1056 21.8503 37.9443 20.9362 36.6538C20.5061 36.0086 20.0759 35.3633 19.6457 34.7181C19.1618 33.9115 19.3231 32.9974 20.0759 32.5134C20.7749 32.0295 21.7428 32.2446 22.2805 32.9974C22.4956 33.32 22.7107 33.6964 22.9795 34.0728Z"
      fill="white"
    />
    <path
      d="M22.9795 43.8411C23.7323 43.0883 24.3776 42.3355 25.0766 41.6365C25.3992 41.3139 25.6681 40.9912 25.9907 40.6686C26.636 40.0234 27.5501 40.0234 28.1953 40.6148C28.8406 41.2063 28.8406 42.1742 28.2491 42.8195C27.0124 44.1637 25.7756 45.4542 24.5389 46.7447C23.4635 47.8739 21.8503 47.7126 20.9362 46.4221C20.5061 45.7769 20.0759 45.1316 19.6457 44.4864C19.1618 43.6798 19.3231 42.7657 20.0759 42.2817C20.7749 41.7978 21.7428 42.0129 22.2805 42.7657C22.4956 43.0883 22.7107 43.4647 22.9795 43.8411Z"
      fill="white"
    />
    <path
      d="M23.1945 26.5866C24.323 26.5866 25.2378 25.6718 25.2378 24.5433C25.2378 23.4148 24.323 22.5 23.1945 22.5C22.0661 22.5 21.1512 23.4148 21.1512 24.5433C21.1512 25.6718 22.0661 26.5866 23.1945 26.5866Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_700_36980"
        x1="34.5455"
        y1="2.70945e-07"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7000FF" />
        <stop offset="1" stopColor="#45009C" />
      </linearGradient>
    </defs>
  </svg>
)

export default ManagementTasksSubcategory
